import { Outlet } from "react-router-dom";
import { ProfesionalProvider } from "../context/ProfesionalContext";


const EditarLandingLayout = () => {
  

  return (
    <ProfesionalProvider>
      <div className="flex w-full">
        <div className="flex-1">
          <Outlet
          />
        </div>
      </div>
    </ProfesionalProvider>
  );
};

export default EditarLandingLayout;


